
import CardImageTop from '@/components/CardImageTop.vue';
import { Option } from '@/models/option';
import { OptionGroup } from '@/models/option-group';
import { Actions } from '@/store/actions';
import PriceUtil from '@/util/price-util';
import he from 'he';
import { computed, ComputedRef, defineComponent, PropType } from 'vue';

import { useStore } from 'vuex';

export default defineComponent({
  name: 'OptionGroupView',
  components: {CardImageTop},
  props: {
    optionGroup: {
      type: Object as PropType<OptionGroup>,
      required: false,
      default: null
    },
    showPrice: {
      type: Boolean,
      required: false,
      default: null
    }
  },
  setup(props) {
    const store = useStore();

    const optionGroupOptions: ComputedRef<Option[]> = computed(() => {
      if (!props.optionGroup) {
        return [];
      }

      return props.optionGroup?.options?.map((optionId: number) => {
        return store.state.options?.find((option: Option) => option.id === optionId);
      });
    });

    function getPreSelectedOptionText(option: Option): string {
      return option.isPreSelected
          ? 'In dem von Ihnen gewählten Leistungsumfang ist dieser Posten bereits enthalten.'
          : '';
    }

    function getOptionPriceForDisplay(option: Option): string {
      return PriceUtil.formatGermanWithFractionsOptional(option.price);
    }

    function htmlDecode(input: string): string {
      return he.decode(input);
    }

    function onOptionSelectionChanged(
        event: Event,
        option: Option) {
      const target = event.target as HTMLInputElement;
      store.dispatch(Actions.OptionSelectionChanged, {selected: target.checked, option});
    }

    return {
      optionGroupOptions,
      getPreSelectedOptionText,
      getOptionPriceForDisplay,
      htmlDecode,
      onOptionSelectionChanged
    };
  }
});
